import tokens from '@/PrimeVue/customDesignTokens';

export default {
  hoverBackground: tokens.list.option.background.colors.hover
};